module.exports = __webpack_public_path__ + "static/media/bg.512bb62d.avif";